import {LOGIN, LOGOUT, ALGO_ERRADO} from '../constants/constants'

export const login = (usuario, senha) => ({
    type : LOGIN,
    usuario, senha
})

export const logout = () => ({
    type : LOGOUT
})

export const algoErrado = (data=true) => ({
    type : ALGO_ERRADO, data
})


// WEBPACK FOOTER //
// ./src/actions/sistema.js